import { DONE, RESET_VIEW, IS_CREATED_BY_ME } from './actionTypes';

const initialState = {
  done: false,
  is_created_by_me: false
}

const actions = (state = initialState, action) => {
  switch (action.type) {
    case DONE:
      return {
        ...state,
        done: true
      };


    case RESET_VIEW:
      return {
        ...state,
        done: false
      };

    case IS_CREATED_BY_ME:
      return {
        ...state,
        is_created_by_me: action.is_created_by_me
      };


    default:
      return state;
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/ViewActions/flow/reducer.js